import React, {Component} from 'react';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {Redirect, withRouter} from 'react-router-dom';
import {requestLogin} from '../../actions/action_auth';
import logo from '../../../res/images/ic_neosvoc-logo-color.svg';
import messages from '../../../res/translations/messages';
import Icon from '../Icon';
import InputErrorMessage from '../InputErrorMessage';
import Footer from '../layout/Footer';

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {username: '', password: ''};
        this.handleChangeUsername = this.handleChange.bind(this, 'username');
        this.handleChangePassword = this.handleChange.bind(this, 'password');
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(field, event) {
        this.setState({[field]: event.target.value});
    }

    handleSubmit(event) {
        event.preventDefault();
        this.props.requestLogin(this.state.username, this.state.password);
    }

    render() {
        const {error, loading, logged} = this.props;
        if (logged) {
            return <Redirect to={{pathname: '/', state: {from: this.props.location}}} />;
        }
        return (
            <>
                <div className="login">
                    <form className="form-signin" onSubmit={this.handleSubmit}>
                        <div className="logo text-center">
                            <img src={logo} alt="NeosVoc" width="36" height="36" />
                            <span>NeosVoc</span>
                        </div>
                        <div className="separator" />
                        <div className="form-content">
                            <div className="form-group">
                                <label htmlFor="inputEmail"><FormattedMessage {...messages.login.email} /></label>
                                <input type="email" id="inputEmail" className="form-control" placeholder="" required autoFocus
                                    value={this.state.username} onChange={this.handleChangeUsername} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="inputPassword"><FormattedMessage {...messages.login.password} /></label>
                                <input type="password" id="inputPassword" className="form-control" placeholder="" required
                                    value={this.state.password} onChange={this.handleChangePassword} />
                                {error && <InputErrorMessage><FormattedMessage {...messages.errors.credentials} /></InputErrorMessage>}
                                <div><a href="#"><FormattedMessage {...messages.login.forgotPassword} /></a></div>
                            </div>
                            <div className="text-center login-button">
                                <button className="btn btn-primary" type="submit" disabled={loading}>
                                    <Icon icon="login" /> <FormattedMessage {...messages.login.login} />
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
                <Footer />
            </>
        );
    }
}
// Invalid email or password.
const mapStateToProps = (state) => ({
    error: state.auth.error,
    loading: state.auth.loading,
    logged: state.auth.logged,
});

export default connect(mapStateToProps, {requestLogin})(withRouter(Login));
